import React from 'react';

import type { ConfidenceLevel, Disposition } from '@hero/hero-types';

import {
    getConfidenceLabel,
    getDispositionLabel,
    getDispositionTagType,
    titleCase
} from './labels';
import * as styles from './style.module.css';

type Reason = {
    pattern: string;
    confidence?: ConfidenceLevel | string;
};

type Props = {
    disposition: Disposition | string;
    reasons?: Reason[];
};

const VALUE_CLASS: Record<string, string> = {
    fail: styles.dispositionValueFail,
    warn: styles.dispositionValueWarn,
    success: styles.dispositionValueSuccess
};

const TopDispositionBadge: React.FC<Props> = ({ disposition, reasons = [] }) => {
    const valueClass = VALUE_CLASS[getDispositionTagType(disposition)] ?? '';

    return (
        <div className={styles.dispositionBlock}>
            {reasons.length > 0 ? (
                <div className={styles.headlineItem}>
                    <span className={styles.eyebrow}>
                        {reasons.length > 1 ? 'Detected issues' : 'Detected issue'}
                    </span>
                    {reasons.map((reason, idx) => (
                        <div key={`${reason.pattern}-${idx}`} className={styles.reasonLine}>
                            <span className={styles.headlineValue}>
                                {titleCase(reason.pattern)}
                            </span>
                            {reason.confidence ? (
                                <span className={styles.reasonMeta}>
                                    {`${getConfidenceLabel(reason.confidence).toLowerCase()} confidence`}
                                </span>
                            ) : null}
                        </div>
                    ))}
                </div>
            ) : null}

            <div className={styles.headlineItem}>
                <span className={styles.eyebrow}>Recommended action</span>
                <span className={`${styles.headlineValue} ${valueClass}`}>
                    {getDispositionLabel(disposition)}
                </span>
            </div>
        </div>
    );
};

export default TopDispositionBadge;
